import React, { useState } from "react";
import { useEffect } from "react";
import { baseURL } from "../../constants/Api";
import axios from "axios";
import CustomAlert from "./CustomAlert";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import ButtonLoader from "../../components/loaders/ButtonLoader";
import { fetchRoomNoAndPhoneNo, setRoomNoAndPhoneNo } from "../../utils/util";
import { useNavigate } from "react-router-dom";
import { HKCommoditySubmitButtonClick } from "../../utils/Analytics";

function Countable(props) {
  // console.log("props",props)
  const navigate = useNavigate();
  const [countableListArray, SetCountableList] = useState([]);
  const [cartArray, SetCartArray] = useState([]);
  const reservationId = localStorage.getItem("reservationId");
  const guestId = localStorage.getItem("guestId");
  const hotelId = localStorage.getItem("hotel-id");
  const appUserId = localStorage.getItem("appUserId");
  const [customAlertMsg, SetCustomAlertMsg] = useState("");
  const [roomNumberError, setRoomNumberError] = useState("");
  const [customAlertDescription, SetCustomAlertDescription] = useState("");
  const [loadingAnimation, SetLoading] = useState(false);
  const [successShow, SetSuccess] = useState(false);
  const [errorShow, SetErrorShow] = useState(false);
  const storedData = fetchRoomNoAndPhoneNo();
  const [roomNo, setRoomNo] = useState(storedData?.room);
  const [confirmRoomNo, setConfirmRoomNo] = useState(storedData?.room);
  const [requestShow, SetRequestShow] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState("");
  const handleRoomNo = (e) => {
    setRoomNo(e.target.value);
  };

  const handleConfirmRoomNo = (e) => {
    setConfirmRoomNo(e.target.value);
  };

  const handleRequest = () => {
    SetRequestShow(true);
  };

  const handleClose = () => {
    SetRequestShow(false);
  };

  useEffect(() => {
    SetCountableList(props.countable);
    setCurrencySymbol(props.currencySymbol);
  }, [props]);

  const handleCounterPlus = (itemId) => {
    SetCountableList((prevCommodities) => {
      const updatedCommodities = prevCommodities.map((item) => {
        if (item.id === itemId) {
          const updatedQuantity = (item.quantity || 0) + 1;

          if (updatedQuantity === 0) {
            SetCartArray((prevCartArray) => {
              return prevCartArray.filter(
                (cartItem) => cartItem.serviceId !== itemId
              );
            });
          } else {
            SetCartArray((prevCartArray) => {
              const existingItemIndex = prevCartArray.findIndex(
                (cartItem) => cartItem.serviceId === itemId
              );

              if (existingItemIndex !== -1) {
                const updatedCartArray = [...prevCartArray];
                updatedCartArray[existingItemIndex].requested = updatedQuantity;
                return updatedCartArray;
              } else {
                return [
                  ...prevCartArray,
                  { serviceId: itemId, requested: updatedQuantity },
                ];
              }
            });
          }

          return {
            ...item,
            quantity: updatedQuantity,
          };
        }
        return item;
      });

      return updatedCommodities;
    });
  };

  const handleClickMinus = (itemId) => {
    SetCountableList((prevCommodities) => {
      const updatedCommodities = prevCommodities.map((item) => {
        if (item.id === itemId) {
          const updatedQuantity = Math.max((item.quantity || 0) - 1, 0);

          if (updatedQuantity === 0) {
            // If the quantity becomes zero, remove the item from the cartArray
            SetCartArray((prevCartArray) => {
              return prevCartArray.filter(
                (cartItem) => cartItem.serviceId !== itemId
              );
            });
          } else {
            // Otherwise, update the count in the cartArray
            SetCartArray((prevCartArray) => {
              const existingItemIndex = prevCartArray.findIndex(
                (cartItem) => cartItem.serviceId === itemId
              );

              if (existingItemIndex !== -1) {
                // Item already exists in the cartArray, update the count
                const updatedCartArray = [...prevCartArray];
                updatedCartArray[existingItemIndex].requested = updatedQuantity;
                return updatedCartArray;
              } else {
                // Item doesn't exist in the cartArray, add it
                return [
                  ...prevCartArray,
                  { serviceId: itemId, requested: updatedQuantity },
                ];
              }
            });
          }

          return {
            ...item,
            quantity: updatedQuantity,
          };
        }
        return item;
      });

      return updatedCommodities;
    });
  };

  let gst = countableListArray[0]?.gst;
  const requestService = async () => {
    let data = JSON.stringify({
      roomNumber: roomNo,
      guestId: guestId,
      hotelId: hotelId,
      appUserId: appUserId,
      reservationId: reservationId,
      gst: gst,
      serviceType: 2,
      items: cartArray,
    });
    let config = {
      method: "post",
      url: `${baseURL}/api/serviceV21`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    try {
      SetLoading(true);
      const response = await axios.request(config);
      if (response.data.success) {
        SetSuccess(true);
        SetErrorShow(false);
        SetCustomAlertMsg("Requested Successfully");
        setRoomNoAndPhoneNo(roomNo)

        var updatedArray = countableListArray.map((item) => ({
          ...item,
          quantity: 0,
        }));
        SetCountableList(updatedArray);
        SetCartArray([]);
        setTimeout(() => {
          SetCustomAlertMsg("");
          SetSuccess(false);
          navigate("../order-history")
        }, 2000);
      }else{
        SetCustomAlertMsg(response.data?.message);
        setTimeout(() => {
          SetCustomAlertMsg("");
          SetErrorShow(false);
        }, 4000);
      }
      SetLoading(false);
    } catch (error) {
      console.log(error);
      SetLoading(false);
      SetErrorShow(true);
      SetCustomAlertMsg("Sorry.. Something went wrong");
      setTimeout(() => {
        SetCustomAlertMsg("");
        SetErrorShow(false);
      }, 4000);
    }
  };

  const submitRequest = () => {
    SetCustomAlertMsg("");
    if(roomNo == ''){
      setRoomNumberError("Enter Room Number");
    }else if(confirmRoomNo == ""){
      setRoomNumberError("Enter Confirm Room Number");
    }else if (roomNo !== confirmRoomNo) {
      setRoomNumberError("Room Numbers Not Match");
    } else {
      HKCommoditySubmitButtonClick();
      requestService();
    }
  };

  return (
    <div>
      <div className="gridTab grid grid-flow-row grid-cols-1 gap-3 gap-x-4 mt-5">
        {countableListArray.map((item, i) => (
          <div
            key={i}
            className="flex flex-row sm:flex-col items-center p-2 w-full bg-[#342F4F] rounded-md  hover:shadow-lg  transition-all"
          >
            <div className="sm:w-full flex bg-gray-200 rounded-md overflow-hidden sm:h-[160px] w-[56px] h-[56px] ">
              <img
                width="100%"
                height="100%"
                className={`flex items-stretch bg-contain object-cover transition w-full sm:h-full ${
                  props.active?.is_open == 1 ? "" : "filter grayscale" }`}
                src={item.image}
                alt="commodities"
              />
            </div>
            <div className="py-3 flex   flex-row gap-2 justify-between w-full lg:ml-0 ml-2 lg:pr-0 pr-2">
              <div className="flex-col pl-[10px] sm:pl-0">
                <div
                  className="sm:mt-2 mt-0 sm:text-base text-[14px] font-medium"
                  title={item.name}
                >
                  {item.name}
                </div>
                <div className="mt-1 sm:text-xs text-[11px] text-[#9A9A9A] font-medium">
                  {item.rate == "Free" ? item.rate : `${currencySymbol}${item.rate}${item.gst !== null ? ` + ${item.gst} % GST` : ''}`}
                </div>
              </div>
               { props.active?.is_open == 1 && 
                <div className="flex items-end">
                  {item.quantity ? (
                    <div className=" flex items-center  gap-3 add-to-cart">
                      <button
                        onClick={() => {
                          handleClickMinus(item.id);
                        }}
                      >
                        -
                      </button>
                      {item.quantity && item.quantity}
                      <button
                        onClick={() => {
                          handleCounterPlus(item.id);
                        }}
                      >
                        +
                      </button>
                    </div>
                  ) : (
                    <button
                      className="add-to-cart"
                      onClick={() => {
                        handleCounterPlus(item.id);
                      }}
                    >
                      Add +
                    </button>
                  )}
                </div>
              }
            </div>
          </div>
        ))}
      </div>

      {cartArray.length != 0 && (
        <div className="place-order-div">
          <div className="place-order">
            <button onClick={handleRequest}>Place order</button>
          </div>
        </div>
        
      )}

      {requestShow && (
        <Transition appear show as={Fragment}>
          <Dialog
            as="div"
            className="relative z-[999999]"
            onClose={handleClose}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black/25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-lg min-h-[300px] transform overflow-hidden rounded-xl bg-[#2E2842] p-6 text-left align-middle shadow-xl transition-all relative food-modal">
                    <Dialog.Title
                      as="h3"
                      className="text-left text-lg font-semibold"
                    >
                      <div className="modalBar mx-auto"></div>
                      <div className="text-left text-white text-lg font-semibold mt-6">
                        House Keeping services
                      </div>
                      <label
                        className="plcLabel pt-4"
                        style={{ color: "gray" }}
                      >
                        Room Number
                      </label>
                      <input
                        className="mt-2 p-2"
                        type="text"
                        value={roomNo}
                        onChange={handleRoomNo}
                        required
                      />
                      <label className="plcLabel" style={{ color: "gray" }}>
                        Confirm Room number
                      </label>
                      <input
                        className="mt-2 p-2"
                        type="text"
                        value={confirmRoomNo}
                        onChange={handleConfirmRoomNo}
                        required
                      />
                      {roomNumberError != "" && <h6 className="text-[red] text-[11px]">{roomNumberError}</h6> }
                      <button
                        disabled={loadingAnimation}
                        onClick={submitRequest}
                        className="relative bookBtn mt-4"
                      >
                        <span> Request service</span>
                        {loadingAnimation && <ButtonLoader />}
                      </button>
                    </Dialog.Title>
                    <div className="mt-2  w-full flex justify-end items-center confirm-order">
                      <div className="flex items-center gap-3"></div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      )}

      {customAlertMsg != "" && (
        <CustomAlert
          hide={() => {
            SetCustomAlertMsg("");
            SetSuccess(false);
            SetCustomAlertDescription("");
            SetErrorShow(false);
          }}
          heading={customAlertMsg}
          para={customAlertDescription}
          submitRequest={submitRequest}
          successShow={successShow}
          errorShow={errorShow}
        />
      )}
    </div>
  );
}

export default Countable;
